"use client";

import React, { useState, useEffect } from "react";
import { Play, Volume2, Maximize, Pause } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Progress } from "@/components/ui/progress";
import { Link } from "@/components/common/Link";
export default function HeroVideoBanner() {
  const [progress, setProgress] = useState(15);
  const [isPlaying, setIsPlaying] = useState(true);
  useEffect(() => {
    let interval: NodeJS.Timeout;
    if (isPlaying) {
      interval = setInterval(() => {
        setProgress(prev => {
          if (prev >= 100) return 0;
          return prev + 0.5;
        });
      }, 100);
    }
    return () => clearInterval(interval);
  }, [isPlaying]);
  const togglePlay = () => setIsPlaying(!isPlaying);
  return <section data-section-id="258450" id="politika-privatnosti" className="relative w-full h-[85vh] min-h-[600px] max-h-[1080px] overflow-hidden bg-background flex items-center justify-center group">
      {}
      <div className="absolute inset-0 w-full h-full">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670497/img/privacy_policy_legal_background.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670497/img/privacy_policy_legal_background.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670497/img/privacy_policy_legal_background.png-wvc-sizes" alt="Professional legal documentation and data protection concept" className="w-full h-full object-cover object-center opacity-40 transition-transform duration-10000 ease-linear scale-105 group-hover:scale-100" loading="eager" />
      </div>

      {}
      <div className="absolute inset-0 bg-gradient-to-b from-primary/20 via-background/60 to-background" />
      <div className="absolute inset-0 bg-gradient-to-t from-background via-background/40 to-transparent" />

      {}
      <div className="relative z-10 text-center px-6 max-w-4xl mx-auto flex flex-col items-center gap-6 mt-12">
        <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold text-foreground font-default tracking-tighter drop-shadow-sm">
          Politika privatnosti
        </h1>
        <p className="text-xl md:text-3xl text-muted-foreground font-default font-medium drop-shadow-none max-w-2xl">
          Vaša privatnost i sigurnost podataka su naš prioritet. Saznajte kako štitimo vaše informacije.
        </p>
        
        <div className="mt-8">
          <Link to="/ContactUsPage">
            <Button size="lg" className="text-lg px-10 py-7 rounded-lg font-semibold shadow-xl bg-primary text-primary-foreground hover:scale-105 transition-transform duration-300">
              Kontaktirajte nas
            </Button>
          </Link>
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 w-full p-4 md:p-8 flex flex-col gap-4 z-20">
        {}
        <div className="flex items-center justify-between text-foreground w-full px-2">
          <div className="flex items-center gap-6">
            <Button onClick={togglePlay} variant="ghost" size="icon" className="text-foreground hover:text-primary transition-colors" aria-label={isPlaying ? "Pause video" : "Play video"}>
              {isPlaying ? <Pause className="w-7 h-7 fill-current" /> : <Play className="w-7 h-7 fill-current" />}
            </Button>
            <Button variant="ghost" size="icon" className="text-foreground hover:text-primary transition-colors" aria-label="Mute video">
              <Volume2 className="w-6 h-6" />
            </Button>
            <span className="text-sm font-mono opacity-60 hidden sm:inline-block">
              0:{Math.floor(progress * 0.6).toString().padStart(2, '0')} / 1:00
            </span>
          </div>
          
          <div className="flex items-center gap-4">
            <span className="text-sm font-medium px-2 py-1 bg-primary/10 rounded-md backdrop-blur-sm text-primary border border-primary/20">
              SECURE
            </span>
            <Button variant="ghost" size="icon" className="text-foreground hover:text-primary transition-colors" aria-label="Fullscreen">
              <Maximize className="w-6 h-6" />
            </Button>
          </div>
        </div>

        {}
        <div className="w-full cursor-pointer group/progress py-2">
          <Progress value={progress} className="h-1.5 md:h-2 bg-muted group-hover/progress:h-3 transition-all duration-300" />
        </div>
      </div>
    </section>;
}